import { MultiForm, useMultiFormContext } from "../../../../../Common/components/MultiForm";
import BasicDetails from "./BasicDetails";
import PersonalInformation from "./PersonalInformation";
import AddressDetail from "./AddressDetail";
import Disclosure from "./Disclosure";
import React from "react";
import { combineMultiFormData } from "../../../../../../util/Helpers";
import { Button } from "react-bootstrap";

export function UserInformation(
    {
        dataKey,
        initialValues = {},
        updateKYC,
        isUpdating,
        isEditable
    }
) {
    const { upsertValue } = useMultiFormContext()
    const { userGroup, userId } = initialValues

    const sections = [
        { title: "Basic Details", key: "basicDetails", Component: BasicDetails },
        { title: "Personal Info", key: "personalData", Component: PersonalInformation },
        { title: "Address", key: "addressData", Component: AddressDetail },
        { title: "Disclosure", key: "disclosuresData", Component: Disclosure },
    ]

    const submit = (values) => {
        const {
            basicDetails: {
                identificationData,
                ...basicDetails
            },
            personalData: {
                birth,
                ...personalData
            },
            addressData,
            disclosuresData,
        } = combineMultiFormData(values).data

        const [birthYear, birthMonth, birthDay] = birth?.split("-")
        personalData.birthDay = parseInt(birthDay)
        personalData.birthMonth = parseInt(birthMonth)
        personalData.birthYear = parseInt(birthYear)

        const { firstName, lastName } = basicDetails

        const upload_data = {
            firstName,
            lastName,
            userId,
            userGroup,
            meta: initialValues
        }

        if (values.addressData?.isValid) upload_data["addressData"] = addressData
        if (values.personalData?.isValid) upload_data["personalData"] = personalData
        if (values.basicDetails?.isValid) {
            upload_data["basicDetails"] = basicDetails
            upload_data["identificationData"] = identificationData
        }
        if (values.disclosuresData?.isValid) {
            // Send old disclosures data if disclosures data has already been signed
            upload_data["disclosuresData"] = initialValues?.disclosuresData?.signedBy
                ? initialValues.disclosuresData
                : disclosuresData
        }

        updateKYC(upload_data)
    }

    return <MultiForm onChange={(values) => upsertValue(dataKey, combineMultiFormData(values))}>
        {
            ({ isDirty, values }) => {
                return (
                    <>
                        {
                            sections.map(({ key, title, Component }) => (
                                <span key={key}>
                                    <Component
                                        dataKey={key}
                                        title={title}
                                        initialValues={initialValues}
                                        isEditable={isEditable}
                                    />
                                    <div className={"my-2"} />
                                </span>
                            ))
                        }
                        {
                            (isDirty && isEditable) && <Button
                                onClick={() => submit(values)}
                                variant={"dark"}
                                className={`w-100 position-sticky bottom-0 zindex-1 mt-2`}
                                disabled={
                                    !(
                                        (values.basicDetails?.isValid && values.basicDetails?.isDirty)
                                        || (values.personalData?.isValid && values.personalData?.isDirty)
                                        || (values.addressData?.isValid && values.addressData?.isDirty)
                                        || (values.disclosuresData?.isValid && values.disclosuresData?.isDirty)
                                    )
                                    || isUpdating
                                }
                            >
                                Apply Changes: {`${(values.basicDetails?.isValid && values.basicDetails?.isDirty) ? "Basic Details," : ""}
                                ${(values.personalData?.isValid && values.personalData?.isDirty) ? "Personal Data," : ""}
                                ${(values.addressData?.isValid && values.addressData?.isDirty) ? "Address Data," : ""}
                                ${(values.disclosuresData?.isValid && values.disclosuresData?.isDirty) ? "Disclosures Data," : ""}`}
                            </Button>
                        }
                    </>
                )
            }
        }
    </MultiForm>
}